import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TextField, Grid, MenuItem, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import APIService from '../services/APIService';
import Moment from 'moment';
import Loading from './Loading';
import { ALACARTE } from '../constants/RestaurantType';
import { withTranslation } from 'react-i18next';

const styles = theme => ({
    paper: {
        position: 'absolute',
        width: theme.spacing.unit * 50,
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
});

class MenuItemAdder extends Component {
    constructor(props) {
        super(props);

        this.menuId = props.menuId || null;

        this.state = {
            open: props.open,

            name: '',
            type: '',
            weight: '',
            price: '',

            types: [],

            loading: true
        };
    }

    addItemToMenu(restaurantId, menuId, item) {
        APIService.storeMenuItem(restaurantId, menuId, item)
            .then((item) => {
                item.food_type = {
                    type: this.props.itemType
                };
                this.props.onAddedItem(item);
            })
            .then(() => {
                this.setState({
                    name: '',
                    type: '',
                    weight: null,
                    price: null,
                });
            });
    }

    addItem() {
        const { restaurantId } = this.props;
        let { name, type, weight, price } = this.state;

        weight = weight ? parseFloat(weight.replace(',', '.')) : null;
        price = price ? parseFloat(price.replace(',', '.')) : null;

        const item = {
            name,
            food_type_id: type,
            weight,
            price
        };

        if (!this.menuId) {
            APIService.storeMenu(restaurantId, {
                "type": this.props.itemType,
                "date_from": new Moment().format(this.props.menuDate || 'Y-M-D')
            }).then((menu) => {
                this.menuId = menu.id;
                this.addItemToMenu(restaurantId, menu.id, item);
            });
        } else {
            this.addItemToMenu(restaurantId, this.menuId, item);
        }

    }

    componentDidMount() {
        APIService.getFoodTypes()
            .then((types) => {
                types = types.filter((type) => type.type === this.props.itemType);
                this.setState({
                    types,
                    loading: false
                });
            });
    }

    render() {
        const { classes } = this.props;

        if (this.state.loading) {
            return <Loading />;
        }

        return (
            <Modal
                open={this.props.open}
                onClose={this.props.onClose}
            >
                <div className={classes.paper}>
                    <Grid container spacing={24}>
                        <Grid item xs={12}>
                            <Typography variant="title">{this.props.t('Lisää ruokalaji')}</Typography>
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                label={this.props.t('Ruokalajin nimi')}
                                value={this.state.name}
                                onChange={(event) => this.setState({ name: event.target.value })}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                select
                                label={this.props.t('Kategoria')}
                                value={this.state.type}
                                onChange={(event) => this.setState({ type: event.target.value })}
                            >
                                {this.state.types.map(type => (
                                    <MenuItem key={type.id} value={type.id}>
                                        {this.props.i18n.language === 'en' ? type.name_en || type.name : type.name}
                                    </MenuItem>
                                ))};
                            </TextField>
                        </Grid>
                        {this.props.itemType == ALACARTE && (
                            <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    label={this.props.t('Paino')}
                                    value={this.state.weight}
                                    onChange={(event) => this.setState({ weight: event.target.value })}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                kg
                                            </InputAdornment>
                                        )
                                    }}
                                />
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <TextField
                                fullWidth
                                type="number"
                                label={this.props.t('Hinta')}
                                value={this.state.price}
                                onChange={(event) => this.setState({ price: event.target.value })}
                                InputProps={{ endAdornment: <InputAdornment position="start">€/kg</InputAdornment> }}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ textAlign: 'right' }}>
                            <Button
                                color="primary"
                                onClick={() => this.addItem()}
                            >
                                {this.props.t('Lisää')}
                            </Button>
                        </Grid>
                    </Grid>
                </div>
            </Modal>
        );
    }
}

MenuItemAdder.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withTranslation()(withStyles(styles)(MenuItemAdder));



// WEBPACK FOOTER //
// ./resources/assets/js/components/MenuItemAdder.js